import script from "./ShareholderIdentificationTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareholderIdentificationTab.vue?vue&type=script&setup=true&lang=ts"

import "./ShareholderIdentificationTab.vue?vue&type=style&index=0&id=7445c660&scoped=true&lang=postcss"

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7445c660"]])

export default __exports__